import {
  Group,
  Paper,
  Space,
  Text,
  SimpleGrid,
  UnstyledButton,
  Accordion,
  Center,
  Button,
  Menu,
} from "@mantine/core";
import React, { useMemo } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { computePayrollPaymentBreakdown } from "./payrollPaymentBreakdown";
import { IconChevronDown } from "@tabler/icons";
import { useTranslation } from "react-i18next";

import {
  IconUsers,
  IconUser,
  IconCircleCheck,
  IconNotes,
  IconTableImport,
  IconCirclePlus,
  IconUserCircle,
  IconBuildingBank,
  IconCircleMinus,
  IconActivity,
  IconCircleX,
  IconHeart,
  IconReceipt2,
  IconAlertCircle,
  IconSquareDot,
  IconInfoCircle,
  IconCoins,
  IconPlayerPause,
} from "@tabler/icons";

import CardStat from "./cardStat";
import { useFormatter } from "../hooks/useFomatter";
import { openFileUrl } from "../utils/openReport";

const PayrollPaymentInfo = ({ form, cols = 4, ...props }) => {
  const [formatter] = useFormatter();
  const { t } = useTranslation();
  const { total, totalSelf, status, bids, payrollBids, totalRefer, payroll } =
    form.values;
  const [api] = useServerApi();
  const { _id: id } = form.values;

  const bidCount =
    payrollBids && payrollBids.length > 0 ? payrollBids.length : bids?.length;

  const paymentBreakdown = useMemo(
    () =>
      computePayrollPaymentBreakdown({
        payrollBids,
        bids,
        total,
        totalSelf,
      }),
    [payrollBids, bids, total, totalSelf],
  );

  const printPayrollSlip = async () => {
    const result = await api.PayrollPayment.printPdf(id);
    await openFileUrl(result.data.url);
  };

  const downloadAllBids = async () => {
    const result = await api.PayrollPayment.downloadAll(id);
    await openFileUrl(result.data.url);
  };

  const stats = [
    {
      icon: IconReceipt2,
      color: "#8278F2",
      label: "Payroll Batch",
      msg: payroll?.code,
    },
    {
      icon: IconSquareDot,
      color: "#ffec00",
      label: "Bids",
      msg: bidCount,
    },
    {
      icon: IconReceipt2,
      color: "#8278F2",
      label: "Total Refer",
      msg: formatter.currency(totalRefer),
    },
    {
      icon: IconInfoCircle,
      color: "#00abfb",
      label: "Status",
      msg: status,
    },
    {
      icon: IconCoins,
      color: "#868e96",
      label: "Pending Payment",
      msg: formatter.currency(paymentBreakdown.pendingAmount),
    },
    {
      icon: IconPlayerPause,
      color: "#fd7e14",
      label: "Hold Payment",
      msg: formatter.currency(paymentBreakdown.holdAmount),
    },
    {
      icon: IconCircleCheck,
      color: "#00b341",
      label: "Settled Payment",
      msg: formatter.currency(paymentBreakdown.settledAmount),
    },
    {
      icon: IconReceipt2,
      color: "#228be6",
      label: "Total Payment",
      msg: formatter.currency(paymentBreakdown.totalAmount),
    },
  ];
  return (
    <>
      {/* <ReactJson src={stats} /> */}
      <SimpleGrid
        cols={cols}
        breakpoints={[
          { maxWidth: "sm", cols: 1 },
          { maxWidth: "md", cols: 2 },
        ]}
        {...props}
      >
        {stats?.map((stat, index) => (
          <CardStat key={index} stat={stat} />
        ))}
      </SimpleGrid>
      <Group position="right" mt={"xl"}>
        <Menu position="bottom-end" withinPortal>
          <Menu.Target>
            <Button size="xs" rightIcon={<IconChevronDown size={14} />}>
              {t("Print Payroll Slip")}
            </Button>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={downloadAllBids}>{t("All Bids")}</Menu.Item>
            <Menu.Item onClick={printPayrollSlip}>{t("Settled Only")}</Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
    </>
  );
};

export default PayrollPaymentInfo;
